import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator, storeAreYouSureModalCallback } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import CustomTextInput from "../../../components/CustomTextInput";
import { AmbarAgreementSchemeService } from "../../../services/AmbarAgreementSchemeService";
import CustomDatePicker from "../../../components/CustomDatePicker";
import CustomNumberInput from "../../../components/CustomNumberInput";
import { GetAmbarAgreementSchemeByIdResponse, GetAmbarAgreementSchemeByIdResponseData } from "../../../models/response/ambarAgreementScheme/GetAmbarAgreementSchemeByIdResponse";
import CustomSwitch from "../../../components/CustomSwitch";
import { GetAmbarAgreementByIdResponse, GetAmbarAgreementByIdResponseAmbarAgreementField, GetAmbarAgreementByIdResponseAmbarAgreementScale } from "../../../models/response/ambarAgreement/GetAmbarAgreementByIdResponse";
import { AmbarAgreementService } from "../../../services/AmbarAgreementService";
import { AddAmbarAgreementRequest } from "../../../models/request/ambarAgreement/AddAmbarAgreementRequest";
import { AddAmbarAgreementResponse } from "../../../models/response/ambarAgreement/AddAmbarAgreementResponse";
import ScaleInformation from "./Components/ScaleInformation";
import { AmbarAgreementSchemeFieldEnum, ProjectEnum } from "../../../models/common/Enums";
import { GetCountryListResponse, GetCountryListResponseData } from "../../../models/response/country/GetCountryListResponse";
import { CountryService } from "../../../services/CountryService";
import { ProjectRegionService } from "../../../services/ProjectRegionService";
import FieldInformation from "./Components/FieldInformation";
import moment from "moment";

/** Çarpan alanı metni → sayı; boşsa null (virgül de kabul). */
const carpanSayi = (s: string) => s.trim() == "" ? null : Number(s.trim().replace(",", "."));

const carpanMetni = (n: number | null | undefined) => n == null ? "" : String(n);

const AmbarAgreementAdd = () => {
    const navigate = useNavigate();
    const pageName = "Kargo Modülü > Nakliye > Anlaşma"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const scaleInformationRef: any = useRef();
    const fieldInformationRef: any = useRef();

    const [ambarAgreementId, setAmbarAgreementId] = useState<string | undefined>(undefined);
    const [refNo, setRefNo] = useState<string | undefined>(undefined);
    const [selectedAgreementScheme, setSelectedAgreementScheme] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [startDate, setStartDate] = useState<string | undefined>(moment().startOf('year').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState<string | undefined>(moment().endOf('year').format('YYYY-MM-DD'));
    const [unitPrice, setUnitPrice] = useState<string | undefined>(undefined);
    const [minPrice, setMinPrice] = useState<string | undefined>('0');
    // QR mesai siparişlerinde gün bazlı ek mesai çarpanları (Faz 1b): boş = 1; resmi tatil boş = günün çarpanı.
    const [carpanHaftaIci, setCarpanHaftaIci] = useState<string>('');
    const [carpanCumartesi, setCarpanCumartesi] = useState<string>('');
    const [carpanPazar, setCarpanPazar] = useState<string>('');
    const [carpanResmiTatil, setCarpanResmiTatil] = useState<string>('');
    const [trCountry, setTrCountry] = useState<GetCountryListResponseData | undefined>(undefined);

    const [ambarAgreementScales, setAmbarAgreementScales] = useState<GetAmbarAgreementByIdResponseAmbarAgreementScale[]>([]);

    const [selectedAmbarAgreementScheme, setSelectedAmbarAgreementScheme] = useState<GetAmbarAgreementSchemeByIdResponseData | undefined>(undefined);

    const [ambarAgreementFields, setAmbarAgreementFields] = useState<GetAmbarAgreementByIdResponseAmbarAgreementField[]>([]);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var response3: GetCountryListResponse = await CountryService.getCountryList('TR');

            if (!response3.isSuccess) {
                toast.error(response3.message)
                return;
            }

            setTrCountry(response3.data.length > 0 ? response3.data[0] : undefined)

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetAmbarAgreementByIdResponse = await AmbarAgreementService.getAmbarAgreementById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setAmbarAgreementId(response.data.ambarAgreementId);
                setRefNo(response.data.refNo);

                if (response.data.agreementSchemeId && response.data.agreementSchemeName) {
                    setSelectedAgreementScheme({ label: response.data.agreementSchemeName, value: response.data.agreementSchemeId });

                    var response2: GetAmbarAgreementSchemeByIdResponse = await AmbarAgreementSchemeService.getAmbarAgreementSchemeById(response.data.agreementSchemeId);

                    if (!response2.isSuccess) {
                        toast.error(response2.message)
                        return;
                    }

                    setSelectedAmbarAgreementScheme(response2.data);

                    setAmbarAgreementFields(response2.data.ambarAgreementSchemeFields.map(function (x) {
                        var ambarAgreementField = (response.data.ambarAgreementFields ?? []).find(a => a.fieldId == x.fieldId);

                        return {
                            ambarAgreementFieldId: ambarAgreementField?.ambarAgreementFieldId ?? Helpers.generateUUID(true),
                            fieldId: x.fieldId,
                            fieldKey: x.fieldKey,
                            fieldName: x.fieldName,
                            operatorId: x.operatorId,
                            operatorName: x.operatorName,
                            value: ambarAgreementField?.value,
                            valueName: ambarAgreementField?.valueName,
                            // Bölüm çok seçimlidir: her seçim sunucuda ayrı satır, ekranda tek alan.
                            values: x.fieldKey == AmbarAgreementSchemeFieldEnum.BOLUM
                                ? (response.data.ambarAgreementFields ?? []).filter(a => a.fieldId == x.fieldId && a.value)
                                    .map(a => ({ ambarAgreementFieldId: a.ambarAgreementFieldId, value: a.value!, valueName: a.valueName }))
                                : undefined
                        }
                    }));
                }

                setStartDate(response.data.startDate);
                setEndDate(response.data.endDate);
                setUnitPrice(response.data.unitPrice?.toString());
                setMinPrice(response.data.minPrice?.toString());
                setCarpanHaftaIci(carpanMetni(response.data.carpanHaftaIci));
                setCarpanCumartesi(carpanMetni(response.data.carpanCumartesi));
                setCarpanPazar(carpanMetni(response.data.carpanPazar));
                setCarpanResmiTatil(carpanMetni(response.data.carpanResmiTatil));

                setAmbarAgreementScales(response.data.ambarAgreementScales);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    /**
     * Kayit sonrasi davranis:
     *  - "liste": eskisi gibi listeye doner
     *  - "yeni": form bosaltilir, bos yeni anlasma ekrani acilir
     *  - "kopyala": kayit kimligi ve kod temizlenir, kalan bilgiler durur;
     *    kullanici degistirip kaydedince yeni anlasma olusur
     */
    type KayitSonrasi = 'liste' | 'yeni' | 'kopyala';

    /** Formu bos yeni kayit durumuna alir. */
    const formuTemizle = () => {
        setAmbarAgreementId(undefined);
        setRefNo(undefined);
        setSelectedAgreementScheme(undefined);
        setSelectedAmbarAgreementScheme(undefined);
        setStartDate(moment().startOf('year').format('YYYY-MM-DD'));
        setEndDate(moment().endOf('year').format('YYYY-MM-DD'));
        setUnitPrice(undefined);
        setMinPrice('0');
        setCarpanHaftaIci('');
        setCarpanCumartesi('');
        setCarpanPazar('');
        setCarpanResmiTatil('');
        setAmbarAgreementScales([]);
        setAmbarAgreementFields([]);
    }

    /**
     * Kaydedilen anlasmayi kopyaya cevirir: kimlik ve kod silinir, alt kayitlar
     * yeni kayit kimligi alir. Diger butun bilgiler ekranda durmaya devam eder.
     */
    const kopyayaCevir = () => {
        setAmbarAgreementId(undefined);
        setRefNo(undefined);

        // Fiyatlar kopyada sifirlanir; kullanici yeni anlasmanin fiyatini bilerek girsin.
        setUnitPrice('0');
        setMinPrice('0');

        setAmbarAgreementScales(oncekiler => oncekiler.map(x => ({ ...x, ambarAgreementScaleId: Helpers.generateUUID(true) })));
        setAmbarAgreementFields(oncekiler => oncekiler.map(x => ({
            ...x,
            ambarAgreementFieldId: Helpers.generateUUID(true),
            // Çok seçimli alanın seçimleri de yeni kayıt olur (kimlikleri boşaltılır).
            values: x.values?.map(v => ({ ...v, ambarAgreementFieldId: undefined }))
        })));
    }

    const saveAmbarAgreement = async (kayitSonrasi: KayitSonrasi = 'liste') => {
        try {
            if (!selectedAmbarAgreementScheme)
                return;
            else if (!selectedAgreementScheme)
                toast.error('Şablon alanını doldurunuz!')
            else if (Helpers.isEmpty(startDate))
                toast.error('Başlangıç Tarihi alanını doldurunuz!')
            else if (Helpers.isEmpty(endDate))
                toast.error('Bitiş Tarihi alanını doldurunuz!')
            else if (selectedAmbarAgreementScheme.isComplete && Helpers.isEmpty(unitPrice))
                toast.error('Birim Fiyat alanını doldurunuz!')
            else if (ambarAgreementFields.some(x => x.fieldKey == AmbarAgreementSchemeFieldEnum.BOLUM && (x.values ?? []).length == 0))
                toast.error('Bölüm seçiniz!')
            else {
                dispatch(storeActivityIndicator(true));

                var obj: AddAmbarAgreementRequest = {
                    ambarAgreementId: ambarAgreementId,
                    agreementSchemeId: selectedAgreementScheme?.value,
                    endDate: endDate,
                    minPrice: minPrice,
                    refNo: refNo,
                    startDate: startDate,
                    unitPrice: unitPrice,
                    carpanHaftaIci: carpanSayi(carpanHaftaIci),
                    carpanCumartesi: carpanSayi(carpanCumartesi),
                    carpanPazar: carpanSayi(carpanPazar),
                    carpanResmiTatil: carpanSayi(carpanResmiTatil),
                    ambarAgreementScales: ambarAgreementScales.map(function (x) {
                        return {
                            ambarAgreementScaleId: x.ambarAgreementScaleId.startsWith('newrecrd') ? undefined : x.ambarAgreementScaleId,
                            interval: x.interval?.toString(),
                            unitPrice: x.unitPrice?.toString(),
                            startPrice: x.startPrice?.toString()
                        }
                    }),
                    ambarAgreementFields: ambarAgreementFields.flatMap(function (x) {
                        // Çok seçimli alan (Bölüm): her seçim ayrı satır olarak gider; kaldırılan seçimin
                        // satırı listede olmadığı için sunucuda silinir.
                        if (x.fieldKey == AmbarAgreementSchemeFieldEnum.BOLUM) {
                            return (x.values ?? []).map(v => ({
                                ambarAgreementFieldId: v.ambarAgreementFieldId?.startsWith('newrecrd') ? undefined : v.ambarAgreementFieldId,
                                fieldId: x.fieldId,
                                value: v.value
                            }));
                        }

                        return [{
                            ambarAgreementFieldId: x.ambarAgreementFieldId?.startsWith('newrecrd') ? undefined : x.ambarAgreementFieldId,
                            fieldId: x.fieldId,
                            value: x.value
                        }];
                    }),
                }

                var response: AddAmbarAgreementResponse = await AmbarAgreementService.addAmbarAgreement(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));

                if (kayitSonrasi == 'liste') {
                    navigate(Helpers.getGoBackUrl())
                    return;
                }

                // Adres cubugundaki kimlik temizlenmezse sayfa yenilendiginde
                // kaydedilen anlasma yeniden acilir.
                setSearchParams({});

                if (kayitSonrasi == 'yeni')
                    formuTemizle();
                else
                    kopyayaCevir();
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const onSchemeChange = async (selectedValue: CustomSingleSelectModel | undefined) => {
        setSelectedAgreementScheme(selectedValue);

        if (!selectedValue) {
            setSelectedAmbarAgreementScheme(undefined);
            return;
        }

        try {
            dispatch(storeActivityIndicator(true));

            var response: GetAmbarAgreementSchemeByIdResponse = await AmbarAgreementSchemeService.getAmbarAgreementSchemeById(selectedValue.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setSelectedAmbarAgreementScheme(response.data);

            setAmbarAgreementFields(response.data.ambarAgreementSchemeFields.map(function (x) {
                return {
                    ambarAgreementFieldId: Helpers.generateUUID(true),
                    fieldId: x.fieldId,
                    fieldKey: x.fieldKey,
                    fieldName: x.fieldName,
                    operatorId: x.operatorId,
                    operatorName: x.operatorName,
                    value: undefined,
                    valueName: undefined,
                    values: x.fieldKey == AmbarAgreementSchemeFieldEnum.BOLUM ? [] : undefined
                }
            }));
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className="row">
                                    <div className="col-md-4">
                                        <CustomTextInput isLabelRequired labelText="Kod" value={refNo} setValue={setRefNo} isDisabled />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            labelText="Şablon"
                                            isLabelRequired
                                            selectedValue={selectedAgreementScheme}
                                            onChange={onSchemeChange}
                                            onMenuOpen={() => AmbarAgreementSchemeService.getAmbarAgreementSchemeList()}
                                            labelName='name'
                                            valueName='ambarAgreementSchemeId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomDatePicker labelText="Başlangıç Tarihi" isLabelRequired value={startDate} setValue={setStartDate} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <CustomDatePicker labelText="Bitiş Tarihi" isLabelRequired value={endDate} setValue={setEndDate} />
                                    </div>
                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="Birim Fiyat" isLabelRequired value={unitPrice} setValue={setUnitPrice} />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="Minimum Fiyat" isLabelRequired value={minPrice} setValue={setMinPrice} />
                                    </div>
                                </div>

                                {/* Gün çarpanı alanları gizlendi (QR Mesai Faz 2, 18.10.2026): katsayı tek set, Çalışma Saatleri'nden gelir.
                                    Kayıtlı değerler geriye uyum için olduğu gibi geri gönderilir; hesapta kullanılmaz. */}
                                <div className="d-flex align-items-center text-muted fs-7 mt-5">
                                    <i className="fa fa-info-circle text-primary me-2" />
                                    Katsayılar Çalışma Saatleri'nden gelir: QR mesai siparişinde birim fiyat × İnsan Kaynakları › Çalışma Saatleri'ndeki gün katsayısı (hafta içi / cumartesi / pazar / resmi tatil).
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    {
                        (selectedAmbarAgreementScheme && selectedAmbarAgreementScheme.isScale) && (
                            <ScaleInformation
                                scaleInformationRef={scaleInformationRef}
                                setAmbarAgreementScales={setAmbarAgreementScales}
                                ambarAgreementScales={ambarAgreementScales}
                            />
                        )
                    }

                    {
                        ambarAgreementFields.length > 0 && (
                            <FieldInformation
                                ambarAgreementFields={ambarAgreementFields}
                                fieldInformationRef={fieldInformationRef}
                                setAmbarAgreementFields={setAmbarAgreementFields}
                                trCountry={trCountry}
                            />
                        )
                    }

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-dark" onClick={() => saveAmbarAgreement('yeni')}>Kaydet &amp; Yeni Anlaşma Ekle</button>
                                </Box>
                                <Box mr="15px">
                                    <button className="btn btn-sm btn-secondary" onClick={() => saveAmbarAgreement('kopyala')}>Kaydet &amp; Kopyala</button>
                                </Box>
                                <Box mr="15px">
                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={() => saveAmbarAgreement('liste')}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default AmbarAgreementAdd;